import Lens from "@mui/icons-material/Lens";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { useCallback } from "react";
import * as React from "react";
import { Control, useController } from "react-hook-form";
import { Color, SketchPicker } from "react-color";
import { useAnchoring } from "hooks";
import Popover from "@mui/material/Popover";

type ColorPickerFieldProps = {
  control: Control<any, object>;
  label?: string;
  required?: boolean;
  zIndex?: number;
};
export default function ColorPickerField({
  control,
  label = "Color",
  required = false,
  zIndex,
}: ColorPickerFieldProps) {
  const { open, handleClose, handleClick, anchorEl } = useAnchoring();
  const validate = useCallback(
    (value: any) =>
      !required ||
      (required && value !== null && value !== undefined && value !== "")
        ? true
        : `${label || "Color"} is required`,
    [required, label]
  );
  const {
    field: { onChange, onBlur, value, ...restField },
  } = useController<any>({
    name: "color",
    control,
    rules: {
      validate,
    },
  });
  return (
    <>
      <FormControl required={required} fullWidth sx={{ mt: 1 }}>
        <InputLabel htmlFor="color-picker-popover" title="Color">
          {label}
        </InputLabel>
        <IconButton
          onClick={handleClick}
          sx={{ justifyContent: "flex-start", mt: 2 }}
        >
          <Stack direction="row" alignItems="center" spacing={2}>
            <Lens sx={{ color: value as string }} />
            <Typography>{value}</Typography>
          </Stack>
        </IconButton>
      </FormControl>
      <Popover
        id="color-picker-popover"
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        sx={zIndex ? { zIndex } : undefined}
      >
        <SketchPicker
          {...restField}
          color={(value as Color) || undefined}
          onChange={(color) => {
            onChange(color?.hex);
            onBlur();
          }}
          onChangeComplete={(color) => {
            onChange(color?.hex);
            onBlur();
          }}
        />
      </Popover>
    </>
  );
}
